__turbopack_context__.v({
  "img": "BreadCrumb-module-scss-module__UOezYG__img",
  "nav": "BreadCrumb-module-scss-module__UOezYG__nav",
});
